import React from 'react';
import Styled from 'styled-components';
import ReactJson from 'react-json-view';
import { FixMe } from '@utils/types';

interface SampleViewProps {
  sample: { [i: string]: FixMe };
}
//
const Container = Styled.div`
  width:100%;
`;
const SampleView = ({ sample }: SampleViewProps) => (
  <Container>
    <ReactJson src={sample} enableClipboard={false} displayDataTypes={false} name={null} />
  </Container>
);

export default SampleView;
